<template>
  <div style="margin-bottom: 5%">
    <el-upload
      ref="uploadFile"
      class="upload-demo"
      :drag="true"
      action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
      :limit="1"
      :on-exceed="handleExceed"
      list-type="picture-card"
      :auto-upload="false"
      :on-success="handleUploadOnSuccess"
      :on-change="handleChange"
      :on-remove="handleRemove"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Suelta tu archivo aquí o <em>haz clic para cargar</em>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    refFather: {}
  },
  data() {
    return {
      fileList: [],
      filesUpload: 0,
      // refFather: null,
      fileReady: false,
      fileSuccess: false
    };
  },
  methods: {
    messageUpload() {
      this.$message.warning(
        "El archivo adjunto es demasiado grande. Por favor, reduce su tamaño."
      );
    },
    async handleUploadOnSuccess(response) {
      this.fileList = response[0];

      if (response) {
        this.refFather.model.FileEvidence = await this.fileList.Url;
        this.refFather.CreatePermissionRequestWithoutFile();
        return (this.filesUpload = 0);
      }
    },
    async handleChange(response) {
      this.filesUpload = 1;
      this.refFather.filesUpload = 1;

      if (this.fileReady) {
        if (response.status == "fail") {
          this.messageUpload();
        }
      }
    },
    handleRemove() {
      this.filesUpload = 0;
      this.refFather.filesUpload = 0;
    },
    submitUpload() {
      // this.refFather = thiss;
      this.fileReady = true;
      this.$refs.uploadFile.submit();
    },
    handleExceed(files) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${
          files.length
        } archivos esta vez, añade hasta ${files.length + 0}`
      );
    }
  }
};
</script>

<style></style>
